// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"a6fa373e","200":"c8a66791","325":"110babbc","506":"9e90ed7b"}[chunkId] + ".chunk.css";
};